import { render, staticRenderFns } from "./ImageSelector.vue?vue&type=template&id=513f8453&scoped=true"
import script from "./ImageSelector.vue?vue&type=script&lang=js"
export * from "./ImageSelector.vue?vue&type=script&lang=js"
import "./ImageSelector.vue?vue&type=style&index=0&id=513f8453&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513f8453",
  null
  
)

export default component.exports